import { render, staticRenderFns } from "./code-verifier.vue?vue&type=template&id=374b9635&scoped=true&"
import script from "./code-verifier.vue?vue&type=script&lang=ts&"
export * from "./code-verifier.vue?vue&type=script&lang=ts&"
import style0 from "./code-verifier.vue?vue&type=style&index=0&id=374b9635&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374b9635",
  null
  
)

export default component.exports